module.exports = __webpack_public_path__ + "media/start_page22.8a4e388f.mp3";